import React from 'react'
import { Button } from 'primereact/button'; 

const TableActions = ({ id, data, getItemtoEdit, setSelectedId,setEditDialogVisible,setDeleteDialogVisible, deleteDisable=false }) => {

    
  
  return (
    <div className='flex flex-row justify-content-center'>
                              <Button
                                icon="pi pi-pencil"
                                label='Edit'
                                severity="success"
                                outlined
                                aria-label="Cancel"
                                className='px-3 py-1 text-xs mr-3'
                                      onClick={() => {
                                        getItemtoEdit(id, data);
                                        setSelectedId(id);
                                        setEditDialogVisible(true);
                                      }}
                              
                              />
              
                              <Button
                                icon="pi pi-trash"
                                label='Delete'
                                disabled={deleteDisable}
                                severity="danger"
                                outlined
                                aria-label="Cancel"
                                className='px-3 py-1 text-xs'
                                      onClick={() => {
                                          setSelectedId(id);
                                          setDeleteDialogVisible(true);
                                      }}
                              
                              />
                          </div>
  )
}

export default TableActions